// Observer.js
import React, { useEffect, useRef, useState } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './Observer.css';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';
import L from 'leaflet';
import 'leaflet-control-geocoder';
import Sidebar from '../Components/Sidebar'; // ← Import Sidebar component
import MinesRemovedImg from '../Pictures/Graphs/MinesRemoved.png';
import AreaClearedImg from '../Pictures/Graphs/AreaCleared.png';
import ReportImg from '../Pictures/report-1.png';
// Example data: replace with your real data

const minesRemovedByDate = {
    '2024-06-01': 5,
    '2024-06-02': 8,
    '2024-06-03': 12,
    // ...etc
};

const data = getLast31Days().map(date => ({
    time: date,
    mines: minesRemovedByDate[date] || 0
}));
function getLast31Days() {
    const days = [];
    for (let i = 30; i >= 0; i--) {
        const d = new Date();
        d.setDate(d.getDate() - i);
        days.push(d.toISOString().slice(0, 10)); // 'YYYY-MM-DD'
    }
    return days;
}

function MapEvents({ onRightClick }) {
    const map = useMap();

    useEffect(() => {
        if (!map) return;

        const contextMenuHandler = (e) => {
            L.popup()
                .setLatLng(e.latlng)
                .setContent(`<button class="set-center-btn">Set View Center Here</button>`)
                .openOn(map);

            setTimeout(() => {
                const btn = document.querySelector('.set-center-btn');
                if (btn) {
                    btn.addEventListener('click', () => {
                        onRightClick(e.latlng);
                        map.closePopup();
                    });
                }
            }, 0);
        };

        map.on('contextmenu', contextMenuHandler);
        return () => map.off('contextmenu', contextMenuHandler);
    }, [map, onRightClick]);

    return null;
}

function Observer() {
    const mapRef = useRef();
    const [fitCenter, setFitCenter] = useState([50.4501, 30.5234]);
    const [showSettingsMenu, setShowSettingsMenu] = useState(false);
    const [activeSetting, setActiveSetting] = useState(null);
    const [showMap, setShowMap] = useState(false);
    const [showReport, setShowReport] = useState(false);
    const eventTypeColors = {
        detected: '#FF0000',
        cleared:  '#00FF00',
        scouted: '#118ACB',

        // Add more types as needed
    };
    const exampleHistory = [
        {
            type: 'detected',
            description: 'Anti-Tank Mine detected at (50.450, 30.523)',
            timestamp: '2024-06-04 10:15:00'
        },
        {
            type: 'cleared',
            description: 'Mined Area at (50.455, 30.530)',
            timestamp: '2024-06-04 11:00:00'
        },
        {
            type: 'scouted',
            description: 'Area scouted at (50.460, 30.540)',
            timestamp: '2024-06-04 12:30:00'
        },
        {
            type: 'cleared',
            description: 'Area reclaimed at (50.465, 30.500)',
            timestamp: '2024-06-04 13:30:00'
        }
    ];
    const [history, setHistory] = useState(exampleHistory);

    const historyContent = (
        <div className="scroll-menu">
            <ul>
                {history.map((event, i) => (
                    <li key={i} style={{ color: eventTypeColors[event.type] || '#000' }}>
                        <strong>{event.type.charAt(0).toUpperCase() + event.type.slice(1)}:</strong> {event.description}
                        <span style={{ fontSize: '0.8em', color: '#888', marginLeft: 8 }}>{event.timestamp}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
    const assetsContent = (
        <div className="scroll-menu">
            <ul>
                {Array.from({ length: 100 }).map((_, i) => (
                    <li key={i}>Asset item {i + 1}</li>
                ))}
            </ul>
        </div>
    );



    const renderSettingsContent = () => (
        <div className="scroll-menu">
            <label className="heatmap-toggle">
                <input
                    type="checkbox"
                    onChange={() => setShowMap(prev => !prev)}
                />
                <span className="slider"></span>
                <span className="toggle-label">Show Map</span>
            </label>
            <label className="heatmap-toggle">
                <input
                    type="checkbox"
                />
                <span className="slider"></span>
                <span className="toggle-label">Show Mines</span>
            </label>
            <label className="heatmap-toggle">
                <input
                    type="checkbox"
                />
                <span className="slider"></span>
                <span className="toggle-label">Show Objects</span>
            </label>
        </div>
    );




    const contentMap = {
        history: historyContent,
        assets: assetsContent,
        settings: renderSettingsContent()
    };

    const handleFitMap = () => {
        const map = mapRef.current;
        if (map && fitCenter) {
            map.setView(fitCenter, 10);
        }
    };

    const handleRightClick = (latlng) => {
        setFitCenter([latlng.lat, latlng.lng]);
    };

    const handleToggleSection = (section) => {
        setShowSettingsMenu(prev => !(activeSetting === section && prev));
        setActiveSetting(section);

    };

    const gridBounds = [
        [50.4, 30.4],
        [50.5, 30.6],
    ];
    const coloredText = [
        { text: "29/155 ", value: "red" },
        { text: " Mines removed", value: "" },
        { text: "42/80:", value: "yellow" },
        { text: "Operators available", value: "" },
        { text: "80/300km²", value: "green" },
        { text: "Area Reclaimed", value: "" },
    ];

// Map value to color
    const getColor = (value) => {
        switch (value) {
            case "green":
                return "#00FF00";
            case "yellow":
                return "#FFFF00";
            case "red":
                return "#FF0000";
            default:
                return "#fff";
        }
    };

    return (
        <div className="app-container">
            <Sidebar
                onFitMap={handleFitMap}
                onToggleSection={handleToggleSection}
                activeSetting={activeSetting}
                showSettingsMenu={showSettingsMenu}
                contentMap= {contentMap}
            />

            <div className="map-container">

                {showMap ? (
                    <MapContainer
                        center={fitCenter}
                        zoom={10}
                        scrollWheelZoom={true}
                        style={{ height: "100%", width: "100%" }}
                        ref={mapRef}
                    >
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <MapEvents onRightClick={handleRightClick} />
                    </MapContainer>
                ) :(
                    <div className="map-placeholder">
                        <div className="centered-images">
                            <img src={MinesRemovedImg} alt="MinesRemoved" className="center-img" />
                            <img src={AreaClearedImg} alt="AreaReclaimed" className="center-img" />
                        </div>
                        <div className="top-right-textbox square">
                            {coloredText.map((item, idx) => (
                                <React.Fragment key={idx}>
                                    <span style={{ color: getColor(item.value) }}>{item.text}</span>
                                    {(idx + 1) % 2 === 0 && <br />}
                                    {" "}
                                </React.Fragment>
                            ))}
                        </div>
                        <button
                            className="bottom-right-btn"
                            onClick={() => setShowReport(true)}
                        >
                            Generate Report
                        </button>
                        {showReport && (
                            <div style={{
                                position: 'fixed',
                                top: 0, left: 0, right: 0, bottom: 0,
                                background: 'rgba(0,0,0,0.7)',
                                zIndex: 2000,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <div style={{
                                    background: '#fff',
                                    borderRadius: 8,
                                    padding: 16,
                                    maxWidth: '90vw',
                                    maxHeight: '90vh',
                                    boxShadow: '0 2px 16px rgba(0,0,0,0.3)',
                                    position: 'relative',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: 8,
                                        right: 8,
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: 8
                                    }}>
                                        <a
                                            href={ReportImg}
                                            download="report.png"
                                            className="modal-action-btn"
                                        >
                                            Download Report
                                        </a>
                                        <button
                                            className="modal-action-btn"
                                            onClick={() => setShowReport(false)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                    <img
                                        src={ReportImg}
                                        alt="Report"
                                        style={{ maxWidth: '80vw', maxHeight: '80vh', border: 'none' }}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <div className="top-right-textbox">
                {coloredText.map((item, idx) => (
                    <React.Fragment key={idx}>
                        <span style={{ color: getColor(item.value) }}>{item.text}</span>
                        {(idx + 1) % 2 === 0 && <br />}
                        {" "}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}

export default Observer;
